<template>
    <div>Descargando...</div>
</template>

<script>
export default {
    name: 'downloadNota',
    props:['params'],
    created(){
        if(this.params){
            //window.location = "http://r1.bdtr.net/hls/downloadNota.php?c="+this.params
            window.location = "https://d8.bdtr.ne/hls/downloadNota.php?c="+this.params
        }else{
            this.$router.push('/');
        }
    }
}
</script>